import React from 'react';
import PropTypes from 'prop-types';
// HOCs
import wrapListFilters from 'hocs/WrapListFilters';
// Custom
import {
  listFeatureSearchFieldShape,
  listFeatureShape,
  listFilterShape,
} from 'constants/PropTypesShapes';
// Components
import CarparkAutoCompleteFilter from 'routes/cpm/routes/carparks/assets/main/CarparkAutoCompleteFilter';
import FiltersCardTemplate from 'components/templates/FiltersCardTemplate';
import BaseListFilter from 'components/filters/BaseListFilter';
import TextFieldFilter from 'components/filters/TextFieldFilter';

const ServiceFeeRuleFilters = ({
  disabled,
  advanced,
  nbFiltersApplied,
  searchFields,
  field,
  filters,
  isFieldDisplayable,
  onFieldChange,
  onFilterFieldChange,
  onReinit,
  onSwitch,
}) => {
  const { carpark, name } = filters;

  return (
    <div className="px-3 mb-3">
      <FiltersCardTemplate
        disabled={disabled}
        advanced={advanced}
        nbFiltersApplied={nbFiltersApplied}
        onReinit={onReinit}
        onSwitch={onSwitch}
      >
        <React.Fragment>
          {!advanced && (
            <div className="col-12 col-md-4 col-xl-3">
              <BaseListFilter
                field={field}
                searchFields={searchFields}
                onChange={onFieldChange}
              />
            </div>
          )}
          {isFieldDisplayable('name') && (
            <div className="col-12 col-md-4 col-xl-3">
              <TextFieldFilter
                label="field.name"
                value={name.value}
                onChange={(value) => onFilterFieldChange('name', value)}
              />
            </div>
          )}
          {isFieldDisplayable('carpark') && (
            <div className="col-12 col-md-4 col-xl-3">
              <CarparkAutoCompleteFilter
                carpark={carpark.value}
                onSelect={(value) => onFilterFieldChange('carpark', value)}
              />
            </div>
          )}
        </React.Fragment>
      </FiltersCardTemplate>
    </div>
  );
};

ServiceFeeRuleFilters.propTypes = {
  // From parent
  listFeatures: listFeatureShape.isRequired, // eslint-disable-line react/no-unused-prop-types
  // From HOC
  disabled: PropTypes.bool.isRequired,
  advanced: PropTypes.bool.isRequired,
  nbFiltersApplied: PropTypes.number.isRequired,
  searchFields: PropTypes.arrayOf(listFeatureSearchFieldShape).isRequired,
  field: PropTypes.string.isRequired,
  filters: PropTypes.shape({
    carpark: listFilterShape,
    name: listFilterShape,
  }).isRequired,
  isFieldDisplayable: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onFilterFieldChange: PropTypes.func.isRequired,
  onReinit: PropTypes.func.isRequired,
  onSwitch: PropTypes.func.isRequired,
};

module.exports = wrapListFilters()(ServiceFeeRuleFilters);



// WEBPACK FOOTER //
// ./routes/cpm/routes/workspaces/assets/serviceFeeRule/ServiceFeeRuleFilters.js